import styled from "@emotion/styled";

const Divider = styled.div`
    height: 0px;
    border: 1px solid #D8D8D8; 
`;

export default Divider;
